import {CreateAccessor, GetDoc, GetDocs} from "mobx-graphlink";
import {DMap} from "./maps/@Map.js";
import {MapObject} from "./mapObjects/@MapObject.js";
import {Vec2, Vec3} from "../../Utils/ThreeJS/VectorStructs.js";

// I don't remember if graphlink-rust sets a consistent ordering by default (I thought it did by id, but results seem otherwise...)
// But, until I investigate that, make sure a consistent ordering exists, by defaulting to order-by-creation-time.
export const GetMapObjects = CreateAccessor((mapID: string, parentID?: string|n, orderByCreationTime = "asc" as null|"asc"|"desc"): MapObject[]=>{
	/*const result = GetDocs({
		params: {filter: {
			map: {equalTo: mapID},
			parent: parentID && {equalTo: parentID},
		}},
	}, a=>a.mapObjects);*/

	// atm, just get all objects for the map, then apply filtering (eg. by parentID) afterward (reason: 1 shared mgl live-query)
	let result = GetDocs({
		params: {filter: {
			map: {equalTo: mapID},
		}},
	}, a=>a.mapObjects).filter(a=>{
		if (parentID != null && a.parent != parentID) return false;
		return true;
	});
	result.forEach(a=>FixMapObjectTypes(a));
	if (orderByCreationTime == "asc") result = result.OrderBy(a=>a.createdAt);
	else if (orderByCreationTime == "desc") result = result.OrderByDescending(a=>a.createdAt);
	return result;
});

export const GetMapObjectsByID = CreateAccessor((mapID: string): Map<string, MapObject>=>{
	const result = GetMapObjects(mapID);
	return result.ToMap(a=>a.id, a=>a);
});

/*export const GetMapObject = CreateAccessor((id: string|n): MapObject|n=>{
	const result = GetDoc({}, a=>a.mapObjects.get(id!));
	FixMapObjectTypes(result);
	return result;
});*/
// atm, just get all objects for the map, then find the one with the matching ID
/*export const GetMapObject = CreateAccessor((id: string|n, mapID: string): MapObject|n=>{
	return GetMapObjects(mapID).find(a=>a.id == id);
});*/
//export const GetMapObject = (id: string|n, mapID: string): MapObject|n=>{
export const GetMapObject = CreateAccessor((id: string|n, mapID: string): MapObject|n=>{
	return GetMapObjectsByID(mapID).get(id!);
});

export function FixMapObjectTypes(obj: MapObject|n) {
	if (obj == null) return;
	obj.position.Cast(Vec3);
}